import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class InputNumber extends Vue {
  @Prop({ default: 0 }) public decimalNumber?: number;
  @Prop({ required: true }) public name?: string;
  @Prop() public label?: string;
  @Prop() public placeholder?: string;
  @Prop({ default: 0, required: false }) public minValue!: number;
  @Prop({ default: Number.MAX_SAFE_INTEGER, required: false }) public maxValue!: number;
  @Prop({ default: false }) public required?: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ default: false }) public readonly?: boolean;
  @Prop() public value?: string;
  protected randomId: string = Math.floor(Math.random() * Math.floor(100000000)).toString();
  protected inputType: string = 'text';
  protected validityError: boolean = false;

  protected mounted() {
    this.inputType = 'text';
    this.validateInput(this.value);
  }

  /**
   * Prevent non-digital inputs characters.
   * @param e Event
   */
  protected preventNonNumericalInput(e: any) {
    e = e || window.event;
    const charCode = (typeof e.which === undefined) ? e.keyCode : e.which;
    let charStr = String.fromCharCode(charCode);
    if (charStr === ',') {
      charStr = '.';
    }
    if (this.value) {
      charStr = this.value + charStr;
    }

    if (!charStr.match(this.getDecimalNumberRegex())) {
      e.preventDefault();
    }
  }

  /**
   * Prevent non-digital inputs characters
   * @param e Event
   */
  protected preventNonNumericalPaste(e: any) {
    e = e || window.event;
    let paste = (e.clipboardData).getData('text') as string;
    if (!paste.match(this.getDecimalNumberRegex())) {
      paste = paste.replace(/\D/g, '');
    } else {
      paste = paste.replace(/[,]/g, '.');
    }
    let nb;

    if (this.value && isNaN(Number(this.value)) || !this.value) {
      nb = paste;
    } else {
      const currValue = String(this.value);
      nb = currValue.slice(0, e.target.selectionStart);
      if (this.value?.match(/[.]/g)) {
        nb += paste.replace(/\D/g, '');
      } else {
        nb += paste;
      }
      nb += currValue.slice(e.target.selectionEnd);
      if (!nb.match(this.getDecimalNumberRegex())) {
        nb = nb.replace(/\D/g, '');
      }
    }
    this.$emit('input', nb);

    e.preventDefault();
  }

  /**
   * Validate the InputNumber field based on min and max allowed values.
   * @param valueStr The value number coming from the input (as string)
   */
  protected validateInput(valueStr: string|undefined|null) {
    if (valueStr === undefined || valueStr === null || valueStr === '') {
      return;
    }

    const value: number = parseFloat(valueStr);
    if (value < this.minValue || value > this.maxValue) {
      this.validityError = true;
    } else {
      this.validityError = false;
    }

    this.$emit('input-number-validity', !this.validityError);
  }

  /**
   * On "input" event, it re-emits the same value and validate it.
   * @param valueStr The formatted input number
   */
  protected onInputFormatAndValidate(valueStr: string) {
    const formattedValue = valueStr.replace(/[,]/g, '.')
    this.$emit('input', formattedValue);
    this.validateInput(formattedValue);
  }

  /**
   * Get decimal number regex (depends on decimalNumber prop)
   * 
   * @returns A regex object
   */
  public getDecimalNumberRegex(): RegExp {
    let regex = new RegExp('^\\d{1,}?$');
    if (this.decimalNumber && this.decimalNumber > 0) {
      regex = new RegExp(`^\\d{1,}[.,]{0,1}\\d{0,${this.decimalNumber}}?$`);
    }

    return regex;
  }
}
